module.exports = __webpack_public_path__ + "img/img6.feb6d02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/04/img6.png
// module id = 237
// module chunks = 0